
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'editUsername'
}

export const createSchema = (t: TFunction) => {
  const regex = /(?=(?![@!$.\-_]))^(?!.+[@!$.\-_]$)(?=(?:.*[a-zA-Z]){4,})(^[a-zA-Z0-9@!$.\-_]{8,30}$)/
  return z.object({
    username: z.string().regex(regex, t('validation.pattern', tConfig))
  })
}

export type EditUsernameFormData = z.infer<ReturnType<typeof createSchema>>
